<template>
	<div>
		<!-- <headers bg="#000" color="#fff"></headers> -->
		<headers></headers>
		<div class="p-6 py-5">
			<!-- <div class="d-sm-flex d-none">
				<nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
					<ol class="breadcrumb">
						<li class="breadcrumb-item" :class="tabIndex==1?'ftw600 cl-theme ftr-1':''" @click="tabIndex=1">{{ $t('becomeTeacher.fillPersonalInfo') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==2?'ftw600 cl-theme ftr-1':''" @click="tabIndex=2">{{ $t('becomeTeacher.uploadPhoto') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==3?'ftw600 cl-theme ftr-1':''" @click="tabIndex=3">{{ $t('becomeTeacher.uploadCertificate') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==4?'ftw600 cl-theme ftr-1':''" @click="tabIndex=4">{{ $t('becomeTeacher.fillEducation') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==5?'ftw600 cl-theme ftr-1':''" @click="tabIndex=5">{{ $t('becomeTeacher.fillIntroduction') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==6?'ftw600 cl-theme ftr-1':''" @click="tabIndex=6">{{ $t('becomeTeacher.uploadVideo') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==7?'ftw600 cl-theme ftr-1':''" @click="tabIndex=7">{{ $t('becomeTeacher.fillTeachingTime') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==8?'ftw600 cl-theme ftr-1':''" @click="tabIndex=8">{{ $t('becomeTeacher.fillTuition') }}</li>
					</ol>
				</nav>
			</div> -->
			<div class="d-sm-flex d-none">
				<nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
					<ol class="breadcrumb">
						<li class="breadcrumb-item" :class="tabIndex==1?'ftw600 cl-theme ftr-1':''" @click="tabIndex=1">1 {{ $t('becomeTeacher.fillPersonalInfo') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==2?'ftw600 cl-theme ftr-1':''" @click="tabIndex=2">2 {{ $t('becomeTeacher.teachingArchives') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==3?'ftw600 cl-theme ftr-1':''" @click="tabIndex=3">3 {{ $t('teacherSet.educationBackground') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==4?'ftw600 cl-theme ftr-1':''" @click="tabIndex=4">4 {{ $t('becomeTeacher.workExperience') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==5?'ftw600 cl-theme ftr-1':''" @click="tabIndex=5">5 {{ $t('becomeTeacher.fillIntroduction') }}</li>
						<li class="breadcrumb-item" :class="tabIndex==6?'ftw600 cl-theme ftr-1':''" @click="tabIndex=6">6 {{ $t('becomeTeacher.teacherServiceTerms') }}</li>
						
					</ol>
				</nav>
			</div>
			<div class="text-center mt-4 ftr-1-25 ftw600"v-if="tabIndex==1">
				{{ $t('becomeTeacher.fillPersonalInfo') }}
			</div>
			<div class="text-center mt-4 ftr-1-25 ftw600"v-if="tabIndex==2">
				{{ $t('becomeTeacher.teachingArchives') }}
			</div>
			<div class="text-center mt-4 ftr-1-25 ftw600"v-if="tabIndex==3">
				{{ $t('teacherSet.educationBackground') }}
			</div>
			<div class="text-center mt-4 ftr-1-25 ftw600"v-if="tabIndex==4">
				{{ $t('becomeTeacher.workExperience') }}
			</div>
			<div class="text-center mt-4 ftr-1-25 ftw600"v-if="tabIndex==5">
				{{ $t('becomeTeacher.fillIntroduction') }}
			</div>
			<div class="text-center mt-4 ftr-1-25 ftw600"v-if="tabIndex==6">
				{{ $t('becomeTeacher.listSix1') }}
			</div>
			<div class="mt-3 flex flex-column alcenter justify-content-center">
				
				<!-- 个人资料 -->
				<div class="becomeTeacher-wid" v-if="tabIndex==1">
					<div class="becomeTeacher-wid">
						{{ $t('becomeTeacher.startCreateProfile') }}
					</div>
					<div class="">
						<span class="cl-red">*</span>{{$t('becomeTeacher.Required')}}
					</div>
					<div class="flex mt-3">
						<div style="width: 50%;padding-right: 10px;">
							<div class="cl-black">
								{{ $t('becomeTeacher.name') }}
							</div>
							<a-input v-model:value="form.name" :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" />
						</div>
						<div style="width: 50%;padding-left: 10px;">
							<div class=" cl-black">
								{{ $t('becomeTeacher.surname') }}
							</div>
							<a-input v-model:value="form.surname" :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" />
							
						</div>
					</div>
					
					<div class="flex mt-3">
						<div style="width: 50%;padding-right: 10px;">
							<div class="cl-black">
								{{ $t('becomeTeacher.nameE') }}<span class="cl-red">*</span>
							</div>
							<a-input v-model:value="form.en_name" :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" />
						</div>
						<div style="width: 50%;padding-left: 10px;">
							<div class=" cl-black">
								{{ $t('becomeTeacher.surnameE') }}<span class="cl-red">*</span>
							</div>
							<a-input v-model:value="form.en_surname" :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" />
						</div>
					</div>
					
					<!-- <div class="flex mt-3">
						<div style="width: 50%;padding-right: 10px;">
							<div class="cl-black">
								{{ $t('becomeTeacher.sex') }}<span class="cl-red">*</span>
							</div>
							<select class="form-select ft16 mt-2" @change="">
								<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
								<option :value="1" >{{$t('userMySetting.male')}}</option>
								<option :value="2" >{{$t('userMySetting.female')}}</option>
							</select>
						</div>
						
					</div> -->
						
					<div class="flex mt-3" style="width: 100%;">
						<div class="cl-black" style="width: 50%;padding-right: 10px;">
							{{ $t('becomeTeacher.nationality') }}
						</div>
						<div class="cl-black" style="width: 50%;padding-left: 10px;">
							{{ $t('becomeTeacher.residence') }}
						</div>
					</div>
					
					<div class="flex mt-2" style="width: 100%;">
						<div class="" style="width: 50%;padding-right: 10px;">
							<select class="form-select ft16 mt-2" v-model="form.nationality" @change="">
								<option :value="null" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
								<option :value="item.id" v-for="(item,index) in travelLocationList ">{{item.name}}</option>
							</select>
						</div>
						<div class="cl-black" style="width: 50%;padding-left: 10px;">
							<a-input v-model:value="form.place_abode" :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" />
						</div>
						
					</div>
					
					<div class="flex mt-3">
						<div style="width: 50%;padding-right: 10px;">
							<div class="cl-black">
								{{ $t('becomeTeacher.phoneNumber') }}<span class="cl-red">*</span>
							</div>
							<a-input v-model:value="form.mobile" :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" />
						</div>
						<div style="width: 50%;padding-left: 10px;">
							<div class=" cl-black">
								{{ $t('becomeTeacher.contactEmail') }}<span class="cl-red">*</span>
							</div>
							<a-input v-model:value="form.email" :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" />
							
						</div>
					</div>
					<div class="flex mt-3">
						<div style="width: 50%;padding-right: 10px;">
							<div class="cl-black">
								{{ $t('becomeTeacher.recommendTeachers') }}<span class="cl-red">*</span>
							</div>
							<a-input  :placeholder="$t('becomeTeacher.teachersNumber')" v-model="form.recommend_email" class="ft16 mt-2" style="height: 40px;" />
						</div>
						
					</div>
					<button type="button" class="btn btn-theme mt-3" @click="toNext">{{ $t('becomeTeacher.nextStep') }}</button>
				</div>
				<!-- 教学档案 -->
				<div class="becomeTeacher-wid" v-if="tabIndex==2">
					<div class="becomeTeacher-wid">
						{{ $t('becomeTeacher.startCreateProfile2') }}
					</div>
					<div class="">
						<span class="cl-red">*</span>{{$t('becomeTeacher.Required')}}
					</div>
					<div class="flex mt-3" style="width: 100%;">
						<div class="cl-black" style="width: 50%;padding-right: 10px;">
							{{ $t('becomeTeacher.speakLanguages') }}<span class="cl-red">*</span>
						</div>
						<div class="cl-black" style="width: 50%;padding-left: 10px;">
							{{ $t('becomeTeacher.level') }}
						</div>
					</div>
					
					<div class="flex mt-2" style="width: 100%;">
						<div class="" style="width: 50%;padding-right: 10px;">
							<select class="form-select ft16 mt-2" v-model="language_id" @change="changeLanguage">
								<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
								<option :value="item.id" v-for="(item,index) in languageList ">{{item.name}}</option>
							</select>
						</div>
						<div class="" style="width: 50%;padding-left: 10px;">
							<select class="form-select ft16 mt-2" v-model="language_level_id"  @change="changeLevel">
								<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
								<option :value="item.id" v-for="(item,index) in languageLevelList ">{{item.name}}</option>
							</select>
						</div>
					</div>
					<div class="mt-2 flex" v-if="form.teacher_language.length>0">
						<div v-for="(item,index) in form.teacher_language" class="pos-re border-gray mr10">
							<div class="ml10 p-2 bg-w ft14" >
								{{item.language_name}} {{item.language_level_name}}
							</div>
							<div class="pos-ab" style="top: -13px;right: -5px;" @click="form.teacher_language.splice(index,1)">
								<a-icon type="close-circle" ></a-icon>
							</div>
							
						</div>
					</div>
					
					<div class="flex mt-3">
						<div style="width: 50%;padding-right: 10px;">
							<div class="cl-black">
								{{ $t('becomeTeacher.professorLevel') }}<span class="cl-red">*</span>
							</div>
							<a-select size="large" style="width: 100%;" mode="multiple" :placeholder="$t('common.select')" 
							class="mt-2" v-model="form.professor_level_id">
								<a-select-option :value="0" >
									{{$t('common.select')}}
								</a-select-option>
								<a-select-option :value="item.id" v-for="(item,index) in professorLevelList">
									{{item.name}}
								</a-select-option>
							</a-select>
						</div>
						
					</div>
					<div class="flex mt-3">
						<div style="width: 50%;padding-right: 10px;">
							<div class="cl-black">
								{{ $t('becomeTeacher.teachingSubjects') }}<span class="cl-red">*</span>
							</div>
							
							<a-select size="large" style="width: 100%;" mode="multiple" :placeholder="$t('common.select')"
							class="mt-2" v-model="form.course_classify_id">
								<a-select-option :value="0" >
									{{$t('common.select')}}
								</a-select-option>
								<a-select-option :value="item.id" v-for="(item,index) in classifyList">
									{{item.name}}
								</a-select-option>
							</a-select>
						</div>
					</div>
					<div class="cl-black mt-3">
						{{ $t('becomeTeacher.specialEducationExperience') }}
					</div>
					<a-select
					      v-model:value="form.special_educational_experience_id"
					      mode="multiple"
					      :placeholder="$t('becomeTeacher.pleaseFill')"
					      style="width: 100%"
						  showArrow
						  class="mainIndex-class-select mt-2"
						  size="large"
						  :options="specialEducationalExperienceL"
					    >
					</a-select>
					<div class="flex mt-3">
						<div style="width: 50%;padding-right: 10px;">
							<div class="cl-black">
								{{ $t('teacherVue.highestEducationLevel') }}<span class="cl-red">*</span>
							</div>
							<select class="form-select ft16 mt-2" @change="" v-model="form.education_background_id">
								<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
								<option :value="item.id" v-for="item in educationBackgroundL">{{item.name}}</option>
							</select>
						</div>
					</div>
					<!-- <div class="cl-black mt-5">
						{{ $t('becomeTeacher.photo') }}
					</div>
					<div class="mt-3">
						<upload-img v-model="form.photo_image"></upload-img>
					</div> -->
					<div class="mt-3 flex justify-content-between">
						<button type="button" class="btn btn-theme" @click="toNext">{{ $t('becomeTeacher.nextStep') }}</button>
						<button type="button" class="btn btn-outline-gray" @click="toPre">{{ $t('becomeTeacher.previousStep') }}</button>
					</div>
				</div>
				<!-- 学历 -->
				<div class="becomeTeacher-wid" v-if="tabIndex==3">
					<div class=" text-center">
						{{$t('becomeTeacher.educationBackground4')}}
					</div>
					<div v-for="(item,index) in form.educational_qualifications_information">
						<div class="flex alcenter mt-4">
							<div>
								<div>
									{{$t('becomeTeacher.yearRange')}}
								</div>
								<a-range-picker valueFormat="YYYY-MM-DD" style="width: 200px;" class="mt-2" v-model="item.yearRange" />
							</div>
							<div class="ml10">
								<div>
									{{$t('becomeTeacher.educationBackground1')}}
								</div>
								<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" 
								 v-model="item.schoolName"/>
							</div>
							<div class="ml10">
								<div>
									{{$t('becomeTeacher.educationBackground2')}}
								</div>
								<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" 
								 v-model="item.diplomaName"/>
							</div>
						</div>
						<div class="mt-3 ftr-1-2 cl-black ftw600">
							{{$t('becomeTeacher.educationBackground3')}}
						</div>
						<div class="flex mt-3">
							<div style="width: 150px;">
								<upload-img v-model="item.photo"></upload-img>
							</div>
							<div class="ml10">
								<div class="ftw600">{{$t('becomeTeacher.listFour2')}}</div>
								<li>{{$t('becomeTeacher.listFour3')}}</li>
								<li>{{$t('becomeTeacher.listFour4')}}</li>
							</div>
						</div>
					</div>
					
					
					<div class="mt-3 cl-theme flex alcenter" @click="addEQI()">
						<img src="../../assets/image/commom/add.png" alt="" class="mr10 photo-20" />
						{{$t('becomeTeacher.educationBackground5')}}
					</div>
					<hr />
					<div class="text-center">
						{{$t('becomeTeacher.educationBackground6')}}
					</div>
					<div class="text-center mt-3">
						{{$t('becomeTeacher.educationBackground7')}}
					</div>
					<div class="text-center mt-2">
						{{$t('becomeTeacher.educationBackground8')}}
					</div>
					<div class="flex around mt-3">
						<div class="btn " style="width: 40%;" 
						:class="form.professional_teacher_qualification.registeredTeacher==1?'btn-outline-theme':'btn-outline-gray'"
						@click="form.professional_teacher_qualification.registeredTeacher = 1">
							{{$t('becomeTeacher.educationBackground9')}}
						</div>
						<div class="btn " style="width: 40%;"
						:class="form.professional_teacher_qualification.registeredTeacher==0?'btn-outline-theme':'btn-outline-gray'"
						@click="form.professional_teacher_qualification.registeredTeacher = 0">
							{{$t('becomeTeacher.educationBackground10')}}
						</div>
					</div>
					<div class="flex alcenter mt-4">
						<div>
							<div>
								{{$t('becomeTeacher.yearRange')}}
							</div>
							<a-date-picker valueFormat="YYYY-MM-DD"  class="mt-2" 
							    style="width: 180px;" v-model="form.professional_teacher_qualification.year" />
						</div>
						<div class="ml10">
							<div>
								{{$t('becomeTeacher.educationBackground11')}}
							</div>
							<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" 
							v-model="form.professional_teacher_qualification.institutionName" />
						</div>
						<div class="ml10">
							<div>
								{{$t('becomeTeacher.educationBackground12')}}
							</div>
							<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" 
							v-model="form.professional_teacher_qualification.certificateName"/>
						</div>
					</div>
					<div class="mt-3 ftr-1-2 cl-black ftw600">
						{{$t('becomeTeacher.educationBackground13')}}
					</div>
					<div class="flex mt-3">
						<div style="width: 150px;">
							<upload-img v-model="form.professional_teacher_qualification.photo"></upload-img>
						</div>
						<div class="ml10">
							<div class="ftw600">{{$t('becomeTeacher.listFour2')}}</div>
							<li>{{$t('becomeTeacher.listFour3')}}</li>
							<li>{{$t('becomeTeacher.listFour4')}}</li>
						</div>
					</div>
					
					<div class="mt-4">
						<hr/>
					</div>
					
					<div class="text-center">
						{{$t('becomeTeacher.educationBackground14')}}
					</div>
					<div class="flex alcenter mt-4">
						<div>
							<div>
								{{$t('becomeTeacher.yearRange')}}
							</div>
							<a-date-picker valueFormat="YYYY-MM-DD"  class="mt-2" 
								v-model="form.other_professional_qualifications.year"
							    style="width: 180px;" />
						</div>
						<div class="ml10">
							<div>
								{{$t('becomeTeacher.educationBackground11')}}
							</div>
							<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;"
							 v-model="form.other_professional_qualifications.institutionName"/>
						</div>
						<div class="ml10">
							<div>
								{{$t('becomeTeacher.educationBackground12')}}
							</div>
							<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;"
							  v-model="form.other_professional_qualifications.certificateName"/>
						</div>
					</div>
					<div class="mt-3 ftr-1-2 cl-black ftw600">
						{{$t('becomeTeacher.educationBackground13')}}
					</div>
					<div class="flex mt-3">
						<div style="width: 150px;" >
							<upload-img v-model="form.other_professional_qualifications.photo"></upload-img>
						</div>
						<div class="ml10">
							<div class="ftw600">{{$t('becomeTeacher.listFour2')}}</div>
							<li>{{$t('becomeTeacher.listFour3')}}</li>
							<li>{{$t('becomeTeacher.listFour4')}}</li>
						</div>
					</div>
					<!-- <div class="mt-3 cl-theme" @click="form.s_other_professional_qualifications.photo.push('')">
						{{$t('becomeTeacher.educationBackground15')}}
					</div> -->
					<hr />
					<div class="text-center">
						{{$t('becomeTeacher.educationBackground16')}}
					</div>
					<div v-for="(item,index) in form.public_examination_results">
						<div class="flex mt-4" >
							<div>
								<div>
									{{$t('becomeTeacher.yearRange')}}
								</div>
								<a-date-picker valueFormat="YYYY-MM-DD"  class="mt-2" 
								    style="width: 180px;" v-model="item.year" />
							</div>
							<div class="ml10" style="flex: 1;">
								<div>
									{{$t('becomeTeacher.educationBackground17')}}
								</div>
								<div class="">
									<div class="flex alcenter">
										<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;"
										 v-model="item.exam"/>
									</div>
									<div class="flex mt-2">
										<div>
											<div>
												{{$t('cashDesk.subject')}}
											</div>
											<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" 
											v-model="item.subject"/>
										</div>
										<div class="ml10">
											<div>
												{{$t('becomeTeacher.educationBackground18')}}
											</div>
											<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;"
											 v-model="item.grade"/>
										</div>
									</div>
								</div>
							</div>
							
						</div>
						<div class="mt-3 ftr-1-2 cl-black ftw600">
							{{$t('becomeTeacher.educationBackground20')}}
						</div>
						<div class="flex mt-3">
							<div style="width: 150px;">
								<upload-img v-model="item.photo_image"></upload-img>
							</div>
							<div class="ml10">
								<div class="ftw600">{{$t('becomeTeacher.listFour2')}}</div>
								<li>{{$t('becomeTeacher.listFour3')}}</li>
								<li>{{$t('becomeTeacher.listFour4')}}</li>
							</div>
						</div>
					</div>
					
					
					<div class="mt-3 cl-theme clickAct flex alcenter " @click="addPER">
						<img src="../../assets/image/commom/add.png" alt="" class="mr10 photo-20" />
						{{$t('becomeTeacher.educationBackground20')}}
					</div>
					<div class="mt-3 flex justify-content-between">
						<button type="button" class="btn btn-theme" @click="toNext">{{ $t('becomeTeacher.nextStep') }}</button>
						<button type="button" class="btn btn-outline-gray" @click="toPre">{{ $t('becomeTeacher.previousStep') }}</button>
					</div>
				</div>
				<!-- 工作經驗 -->
				<div class="becomeTeacher-wid" v-if="tabIndex==4">
					<div v-for="(item,index) in form.work_experience">
						<div class="flex alcenter">
							<div>
								<div>
									{{$t('becomeTeacher.yearRange')}}
								</div>
								<a-range-picker valueFormat="YYYY-MM-DD" style="width: 200px;" class="mt-2"
								 v-model="item.yearRange"/>
							</div>
							<div class="ml10">
								<div>
									{{$t('becomeTeacher.workingBody')}}
								</div>
								<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;"
								 v-modal="item.schoolName"/>
							</div>
							<div class="ml10">
								<div>
									{{$t('becomeTeacher.position')}}
								</div>
								<a-input :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;"
								 v-model="item.diplomaName" />
							</div>
						</div>
						<div class="mt-3 ftw600 ftr-1-25">
							{{$t('becomeTeacher.listFour1')}}
						</div>
						<div class="flex mt-3">
							<div style="width: 150px;">
								<upload-img v-model="item.photo"></upload-img>
							</div>
							<div>
								<div class="ftw600">{{$t('becomeTeacher.listFour2')}}</div>
								<li>{{$t('becomeTeacher.listFour3')}}</li>
								<li>{{$t('becomeTeacher.listFour4')}}</li>
							</div>
						</div>
					</div>
					
					
					<div class="ftw600 cl-theme mt-3" @click="addWE">
						{{$t('becomeTeacher.listFour5')}}
					</div>
					<!-- <div class="cl-black mt-5">
						{{ $t('becomeTeacher.education') }}
					</div>
					<select class="form-select ft16 mt-2" v-model="form.education_background_id">
						<option :value="0" selected>{{ $t('becomeTeacher.pleaseFill') }}</option>
						<option :value="item.id" v-for="(item,index) in educationBackgroundL ">{{item.name}}</option>
					</select> -->
					<div class="mt-3 flex justify-content-between">
						<button type="button" class="btn btn-theme" @click="toNext">{{ $t('becomeTeacher.nextStep') }}</button>
						<button type="button" class="btn btn-outline-gray" @click="toPre">{{ $t('becomeTeacher.previousStep') }}</button>
					</div>
				</div>
				<!-- 个人介绍 -->
				<div class="becomeTeacher-wid" v-if="tabIndex==5">
					<div class="cl-black mt-5">
						{{ $t('becomeTeacher.listFive1') }}
					</div>
					<div class="cl-black mt-3">
						{{ $t('becomeTeacher.listFive2') }}
					</div>
					<a-input v-model:value="form.synopsis" :placeholder="$t('becomeTeacher.pleaseFill')" class="ft16 mt-2" style="height: 40px;" />
					<div class="cl-black mt-3">
						{{ $t('becomeTeacher.listFive3') }}
					</div>
					<div class="cl-black mt-3 ftr-1-25">
						{{ $t('becomeTeacher.listFive4') }}
					</div>
					<div class="cl-info mt-3">
						{{ $t('becomeTeacher.selfIntroduction') }}
					</div>
					<div class="mt-2">
						<quill-editor ref="myQuillEditor" v-model="content" :options="editorOption"
						 @change="onEditorChange($event)"/>
					</div>
					<div class="cl-black mt-3">
						{{ $t('becomeTeacher.listFive5') }}
					</div>
					<!-- <div class="mt-2">
						<upload-img-list v-model="form.introduce_images"></upload-img-list>
					</div> -->
					<div class="mt-3 flex justify-content-between">
						<button type="button" class="btn btn-theme" @click="toNext">{{ $t('becomeTeacher.nextStep') }}</button>
						<button type="button" class="btn btn-outline-gray" @click="toPre">{{ $t('becomeTeacher.previousStep') }}</button>
					</div>
				</div>
				<!-- 老師服務條款 -->
				<div class="becomeTeacher-wid" v-if="tabIndex==6">
					<div class="cl-black mt-5">
						{{ $t('becomeTeacher.listSix2') }}
					</div>
					<div class="flex mt-2">
						 <textarea
						      ref="myTextarea"
						      @scroll="checkScroll"
							  disabled
						      v-model="teacher_service_terms"
						      style="width: 100%;height: 260px;"
						    ></textarea>
						<!-- <a-textarea placeholder="请输入内容" :auto-size="{ minRows: 10 }" v-model="teacher_service_terms" /> -->
					</div>
				
					<div class="flex alcenter mt-4">
						<a-checkbox  v-model="agreement">{{$t('becomeTeacher.listSix3')}}</a-checkbox>
					</div>
					<div class="mt-3 flex justify-content-between">
						<button type="button" class="btn btn-theme" @click="submit() ">{{ $t('becomeTeacher.submit') }}</button>
						<button type="button" class="btn btn-outline-gray" @click="toPre">{{ $t('becomeTeacher.previousStep') }}</button>
					</div>
				</div>
			</div>
		</div>
		<a-modal
		    width="300px"
		   :title="null"
		    v-model="showSuccess"
		     @ok="showSuccess = false"
		    :footer="null"
		    >
				<div class="text-center">
					<div class="ftr-1-25 ftw600">
						{{$t('becomeTeacher.modalSuccess1')}}
					</div>
					<div class="mt-4">
						{{$t('becomeTeacher.modalSuccess2')}}
					</div>
					<div class="mt-3">
						{{$t('becomeTeacher.modalSuccess3',{num:form.id})}}
					</div>
					<div class="btn mt-4 btn-theme" @click="submissionSuccessful">
						{{$t('becomeTeacher.modalSuccess4')}}
					</div>
				</div>
			
		</a-modal>
		<!-- 分成比例 -->
		<div v-if="divideIntoVisible">
			<view-commission :visible="divideIntoVisible" @cancel="divideIntoHandleCancel"></view-commission>
		</div>
		<!-- 添加课程 -->
		<div v-if="classVisible">
			<add-class :visible="classVisible" @cancel="classHandleCancel" :typeId="courseClassifyId"
			:course_id="courseInfo.course_id" :list="classList" :form="form" :money="classMoney" :tCMoney="teacherClassMoney" ></add-class>
		</div>
	</div>
</template>

<script>
	import moment from "moment"
	import selectTimeRange from "./components/selectTimeRange.vue"
	import uploadImg from "../../components/upload/upload.vue"
	import Quill from 'quill'
	import ImageUploader from 'quill-image-uploader';
	import uploadImgList from '../../components/upload/list.vue'
	import addClass from "./components/addClass.vue";
	import viewCommission from "./components/viewCommission.vue";
	// 注册图片上传插件
	Quill.register('modules/imageUploader', ImageUploader);

	export default {
		components: {
			selectTimeRange,
			uploadImg,
			uploadImgList,
			addClass,
			viewCommission
		},
		data() {
			return {
				tabIndex: 1,
				form: {
					language_id: 0,
					language_level_id: 0, //语言等级ID
					professor_level_id: undefined, //教授级别ID
					special_educational_experience_id: [], //特殊教育经验ID
					education_background_id: 0, //学历ID
					name: '', //老师名称
					surname:'',//姓氏
					photo_image: '', //老师照片
					certificate_image: [], //证书图片
					synopsis: '', //简介
					self_introduction_content: '', //自我介绍
					introduce_images:[],//图片介绍
					video_files:[],//视频介绍
					experience_price:[],//体验课价格
					teacher_language:[],
					nationality:null,//国籍
					place_abode:'',//居住地
					mobile:'',//手机号码
					email:'',//电子邮箱
					recommend_email:'',//推荐老师邮箱
					course_classify_id:undefined,
					en_name:'',
					en_surname:'',
					educational_qualifications_information:[
						{
							yearRange:['',''],
							schoolName:'',
							diplomaName:'',
							photo:''
						}
					],
					professional_teacher_qualification:{
						registeredTeacher:0,
						year:'',
						institutionName:'',
						certificateName:'',
						photo:''
					},
					other_professional_qualifications:{
						year:'',
						institutionName:'',
						certificateName:'',
						photo:''
					},
					public_examination_results:[{
						year:'',
						exam:'',
						subject:'',
						grade:'',
						photo:''
						
					}],
					work_experience:[{
						yearRange:['',''],
						schoolName:'',
						diplomaName:'',
						photo:''
					}]
				},
				language_id:0,
				language_level_id:0,
				aotuForm: {
					coach_id: 0,
					private_scheduling_duration: '30', //课程时长
					private_scheduling_interval: '30', //时间间隔
					show_store_data: [{
						rengeTime: [],
						start_s: '',
						end_s: '',
						day_index: [1, 2, 3, 4, 5, 6, 7]
					}],
					store_data: []
				},
				weekList: [{
						value: 1,
						title: '周一'
					},
					{
						value: 2,
						title: '周二'
					},
					{
						value: 3,
						title: '周三'
					},
					{
						value: 4,
						title: '周四'
					},
					{
						value: 5,
						title: '周五'
					},
					{
						value: 6,
						title: '周六'
					},
					{
						value: 7,
						title: '周日'
					}
				],
				showTimeList: [],
				selectWeek: 1,
				weekCountList: [], //用来数据展示计算的数组，以周为基础
				deadlineDate: '',
				divideIntoVisible: false,
				classVisible: false,
				languageList: [], //语言列表
				selectLanguageList: [],
				languageLevelList: [], //级别
				professorLevelList: [], //教授级别
				specialEducationalExperienceL: [], //特殊教育经历
				educationBackgroundL: [], //学历

				content: '',
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['blockquote', 'code-block'],
							[{ 'header': 1 }, { 'header': 2 }],
							[{ 'list': 'ordered'}, { 'list': 'bullet' }],
							[{ 'script': 'sub'}, { 'script': 'super' }],
							['clean'],
							['link', 'image'] // 添加图片按钮
						],
						imageUploader: {
							upload: (file) => {
								return new Promise((resolve, reject) => {
									// 替换为你的实际上传接口
									this.$http.upload(file)
										.then(response => {
											// 假设接口返回图片的 URL
											resolve(response.fullurl); 
										})
										.catch(error => {
											reject(error);
										});
								});
							}
						}
					},
					theme: 'snow',
					placeholder: '请输入内容...',
					readOnly: false
				},
				videoPath:'',
				currency:localStorage.getItem('currency'),
				classifyList:[],//课程分类
				courseClassifyId:0,//课程分类ID
				courseList:[],
				courseInfo:{
					course_id:0,
					teacherCourse:[]
				},
				effective_type_data:1,
				teacher_time:[],
				formTeacherC:[],//老师的课程信息
				formTeacherItem:{},//展示老师课程信息
				formTeacherTypeId:0,
				classMoney:0,//一堂课的钱
				teacherClassMoney:0,//老师一堂课所得
				classList:[
					{
						num:5,
						discount:'',
						pl_discount:'0-9%',
						money:'',
						showMoney:'',
						selected:false,
						max:'9'
					},
					{
						num:10,
						discount:'',
						pl_discount:'0-19%',
						money:'',
						showMoney:'',
						selected:false,
						max:'19'
					},
					{
						num:20,
						discount:'',
						pl_discount:'0-29%',
						money:'',
						showMoney:'',
						selected:false,
						max:'29'
					}
				],
				
				showSuccess:false,
				
				travelLocationList:[],
				teacher_service_terms:'',
				checkRead:false,//判断老师服务协议是否阅读到最下面
				agreement:false,
			}
		},
		async created() {
			let arr = await this.informationIntegration(['language', 'languageLevel', 'professorLevel',
				'specialEducationalExperience', 'educationBackground','travelLocation'
			])
			this.languageList = arr.list.language.list
			this.languageLevelList = arr.list.languageLevel.list
			this.travelLocationList = arr.list.travelLocation.list
			this.professorLevelList = arr.list.professorLevel.list.map(item=>{
				item.value = item.id
				item.label = item.name
				return item
			})
			this.professorLevelList.unshift({
				value:" ",
				label:this.$t('common.select')
			})
			this.specialEducationalExperienceL = arr.list.specialEducationalExperience.list.map(item=>{
				item.value = item.id
				item.label = item.name
				return item
			})
			this.specialEducationalExperienceL.unshift({
				value:" ",
				label:this.$t('common.select')
			})
			this.educationBackgroundL = arr.list.educationBackground.list
			if(this.userInfo.teacher_id){
				this.getTeacherInfo()
			}
			this.getClassifyList(1)
			this.getCategory()
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			submit(){
				if(!this.checkRead){
					this.$message.error(this.$t('common.afterReading'))
					return
				}
				if(!this.agreement){
					this.$message.error(this.$t('common.agreeAgreement'))
					return
				}
				
				this.showSuccess = true
			},
			checkScroll(){
				 const textarea = this.$refs.myTextarea;
				      // 检查是否滚动到了底部
				      if (textarea.scrollTop + textarea.clientHeight >= textarea.scrollHeight) {
				        console.log('Scrolled to the bottom!');
						this.checkRead = true
				      }
			},
			getCategory(){
				this.$http.api('index/category',{
					pid:0,
					keywords:'teacher_service_terms'
				}).then(res=>{
					console.log("res",res);
					this.teacher_service_terms = res.list[0].description
				})
			},
			submissionSuccessful(){
				this.showSuccess = false
				this.setUserInfo()
				this.$router.push('/')
			},
			addEQI(){
				this.form.educational_qualifications_information.push({
					yearRange:['',''],
					schoolName:'',
					diplomaName:'',
					photo:''
				})
			},
			addPER(){
				this.form.public_examination_results.push({
					year:'',
					exam:'',
					subject:'',
					grade:'',
					photo:''
				})
			},
			addWE(){
				this.form.work_experience.push({
					yearRange:['',''],
					schoolName:'',
					diplomaName:'',
					photo:''
				})
			},
			// 课程添加
			agencyCourse(){
				let arr = []
				arr.push({
					price:this.classMoney,
					quantity:1,
					discount:0,
					once_price:this.classMoney,
				})
				this.classList.forEach((item,index)=>{
					if(item.selected){
						arr.push({
							price:item.money*item.num,
							quantity:item.num,
							discount:item.discount,
							once_price:item.money,
						})
					}
				})
				this.$http.api('teacher/teacher/agencyCourse',{
					course_id:this.courseInfo.course_id,
					teacherCourse:arr
				}).then(res=>{
					this.$message.success(this.$t('addClass.saveSuccess'))
					this.classHandleCancel()
					this.getClassifyList(1)
				})
			},
			// 计算不同堂数的价钱
			getClassMoney(){
				let num = Number(this.form.teacher_level.extraction_ratio)/100 //平台抽成比例
				this.teacherClassMoney = this.classMoney-this.classMoney * num //老师一堂课收到的钱
				this.classList.forEach((item,index)=>{
					if(item.discount>item.max){
						item.discount = item.max
					}
					let disNum = 0
					item.discount !==''?disNum = Number(item.discount)/100:''
					item.showMoney = this.classMoney - this.classMoney*disNum
					item.money = this.teacherClassMoney - this.teacherClassMoney*disNum
					// console.log(item);
				})
			},
			// 课程分类
			async getClassifyList(teacherCourse){
				await this.$http.api('course/classifyList',{
					includeCourse:1,
					teacherCourse:teacherCourse?this.form.id:''
				}).then(res=>{
					this.classifyList = res.list
					console.log("teacherCourse",teacherCourse);
					if(teacherCourse&&res.list.length!=0){
						this.formTeacherC=res.list
						this.formTeacherTypeId = res.list[0].id
						this.formTeacherItem = res.list[0].course
					}
				})
				
			},
			// 根据课程分类ID获取课程列表
			getCourse(edit){
				this.$http.api('course/courseList',{
					courseClassifyId:this.courseClassifyId
				}).then(res=>{
					this.courseList = res.list
					edit?'':this.courseInfo.course_id = 0
				})
			},
			// 设置课程价格
			setEditClass(typeId,classItem){
				// this.getClassifyList()
				this.courseClassifyId = typeId
				// this.getCourse(true)
				this.courseInfo.course_id = classItem.id
				this.classList.forEach((item,index)=>{
					classItem.teacherCourse.forEach((it,ind)=>{
						if(it.quantity==1){
							this.classMoney = Number(it.once_price) 
							this.teacherClassMoney = Number(it.once_price) 
						}
						if(item.num==it.quantity){
							item.discount=it.discount
							item.money=it.once_price
							item.selected=true
						}
					})
				})
				this.getClassMoney()
				this.classVisible = true
			},
			teacherCourseDelete(id){
				this.$confirm({
					title: this.$t('common.wantToDelete'),
					content:this.$t('common.wantToDelete'),
					okText: this.$t('common.delete'),
					okType: "danger",
					cancelText: this.$t('common.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('teacher/teacher/teacherCourseDelete',{
							course_id:id
						}).then(res=>{
							this.$message.success(this.$t('common.operationSuccessful'),1,()=>{
								this.getClassifyList(1)
							})
							
						})
					},
					onCancel: () => {
						console.log("Cancel");
					},
				});
				
			},
			classHandleCancel() {
				this.courseClassifyId = 0
				this.courseInfo.course_id = 0
				this.classList = [
					{
						num:5,
						discount:'',
						pl_discount:'0-9%',
						money:'',
						showMoney:'',
						selected:false,
						max:'9'
					},
					{
						num:10,
						discount:'',
						pl_discount:'0-19%',
						money:'',
						showMoney:'',
						selected:false,
						max:'19'
					},
					{
						num:20,
						discount:'',
						pl_discount:'0-29%',
						money:'',
						showMoney:'',
						selected:false,
						max:'29'
					}
				]
				this.classMoney = 0
				this.teacherClassMoney = 0
				this.classVisible = false
				this.getClassifyList(1)
			},
			
			changeLanguage() {
				
			},
			changeLevel(){
				let language_name='',language_level_name = ''
				this.languageList.forEach((item,index)=>{
					if(item.id==this.language_id){
						language_name = item.name
					}
				})
				
				this.languageLevelList.forEach((item,index)=>{
					if(item.id==this.language_level_id){
						language_level_name = item.name
					}
				})
				this.form.teacher_language.push({
					language_level_name,
					language_name,
					language_id:this.language_id,
					language_level_id:this.language_level_id
				})
			},
			teacherUpdate() {
				// this.form.educational_qualifications_information = this.form.s_educational_qualifications_information
				// this.form.professional_teacher_qualification = this.form.s_professional_teacher_qualification
				// this.form.other_professional_qualifications = this.form.s_other_professional_qualifications
				// this.form.public_examination_results = this.form.s_public_examination_results
				// this.form.work_experience = this.form.s_work_experience
				this.$http.api('teacher/teacher/update',this.form ).then(res => {
					if(this.tabIndex==8){
						this.$message.success(this.$t('common.updataSuccess'),1,()=>{
							this.$router.push('/')
						})
					}
					
				})
			},
			getTeacherInfo(){
				this.$http.api('teacher/teacher/info').then(res=>{
					res.info.professor_level_id = res.info.professor_level_id?this.changeSToN(res.info.professor_level_id):''
					res.info.course_classify_id = res.info.course_classify_id?this.changeSToN(res.info.course_classify_id):''
					res.info.special_educational_experience_id = res.info.special_educational_experience_id?this.changeSToN(res.info.special_educational_experience_id):''
					
					this.form = res.info
					this.content = this.form.self_introduction_content
					!this.form.introduce_images?this.form.introduce_images=[]:''
					!this.form.video_files?this.form.video_files=[]:''
					!this.form.educational_qualifications_information?this.form.educational_qualifications_information=[
						{
							yearRange:['',''],
							schoolName:'',
							diplomaName:'',
							photo:''
						}
					]:''
					
					!this.form.professional_teacher_qualification?this.form.professional_teacher_qualification = {
						registeredTeacher:0,
						year:'',
						institutionName:'',
						certificateName:'',
						photo:''
					}:''
					
					!this.form.other_professional_qualifications?this.form.other_professional_qualifications={
						year:'',
						institutionName:'',
						certificateName:'',
						photo:''
					}:''
					!this.form.public_examination_results?this.form.public_examination_results=[{
						year:'',
						exam:'',
						subject:'',
						grade:'',
						photo:''
						
					}]:''
					!this.form.work_experience ? this.form.work_experience=[{
						yearRange:['',''],
						schoolName:'',
						diplomaName:'',
						photo:''
					}]:''
					
					
					
					this.form.teacher_language.forEach((item,index)=>{
						this.languageList.forEach((t,i)=>{
							if(item.language_id==t.id){
								item.language_name = t.name
							}
						})
						this.languageLevelList.forEach((t,i)=>{
							if(item.language_level_id==t.id){
								item.language_level_name = t.name
							}
						})
					})
				})
			},
			// 老师授课时间
			timeUpdateNew(){
				this.$http.api('teacher/teacher/timeUpdateNew',{
					teacher_time:this.teacher_time
				}).then(res=>{
					
				})
			},
			// 老师授课时间回显
			timeListNew(){
				this.$http.api('teacher/teacher/timeListNew').then(res=>{
					if(res.teacherTime){
						this.teacher_time = res.teacherTime
						this.aotuForm.show_store_data =  [{
						rengeTime: [],
						start_s: '',
						end_s: '',
						day_index: [1, 2, 3, 4, 5, 6, 7]
					}]
						this.teacher_time.forEach((item,index)=>{
							let arr = []
							item.monday_switch==1?arr.push(1):''
							item.tuesday_switch==1?arr.push(2):''
							item.wednesday_switch==1?arr.push(3):''
							item.thursday_switch==1?arr.push(4):''
							item.friday_switch==1?arr.push(5):''
							item.saturday_switch==1?arr.push(6):''
							item.sunday_switch==1?arr.push(7):''
							let obj={
								day_index:arr,
								end_s:item.max_time,
								start_s:item.min_time,
								rengeTime:[item.min_time,item.max_time]
							}
							this.effective_type_data = Number(item.effective_type_data) 
							this.deadlineDate = item.effective_type_max_time
							this.aotuForm.show_store_data.push(obj)
						})
					}
				})
			},
			setVideo(){
				this.form.video_files.push(this.videoPath)
				this.videoPath = ''
			},
			delVideo(index){
				this.form.video_files.splice(index,1)
			},
			
			onEditorChange({
				quill,
				html,
				text
			}) {
				console.log('editor change!', quill, html, text)
				this.content = html
				this.form.self_introduction_content = html
			},



			async toNext() {
				// if(this.tabIndex==1&&!this.form.name){
				// 	this.$message.error(this.$t('becomeTeacher.hint1'))
				// 	return
				// }
				// if(this.tabIndex==1&&!this.form.surname){
				// 	this.$message.error(this.$t('becomeTeacher.hint2'))
				// 	return
				// }
				// if(this.tabIndex==1&&this.form.teacher_language.length==0){
				// 	this.$message.error(this.$t('becomeTeacher.hint3'))
				// 	return
				// }
				// if(this.tabIndex==1&&!this.form.professor_level_id){
				// 	this.$message.error(this.$t('becomeTeacher.hint4'))
				// 	return
				// }
				// if(this.tabIndex==1&&this.form.special_educational_experience_id.length==0){
				// 	this.$message.error(this.$t('becomeTeacher.hint5'))
				// 	return
				// }
				
				if(this.tabIndex<8){
					await this.teacherUpdate()
				}
				console.log("this.tabIndex",this.tabIndex);
				if(this.tabIndex==6){
					await this.timeListNew()
				}
				if(this.tabIndex==7){
					this.teacher_time = []
					this.aotuForm.show_store_data.forEach((item,index)=>{
						let obj={
							monday_switch:item.day_index.includes(1)?1:0,
							tuesday_switch:item.day_index.includes(2)?1:0,
							wednesday_switch:item.day_index.includes(3)?1:0,
							thursday_switch:item.day_index.includes(4)?1:0,
							friday_switch:item.day_index.includes(5)?1:0,
							saturday_switch:item.day_index.includes(6)?1:0,
							sunday_switch:item.day_index.includes(7)?1:0,
							min_time:item.start_s,
							max_time:item.end_s,
							effective_type_data:this.effective_type_data,
							effective_type_min_time:this.getTodayDate(),
							effective_type_max_time:this.deadlineDate,
						}
						this.teacher_time.push(obj)
					})
					await this.timeUpdateNew()
					await this.getClassifyList(1)
				}
				this.tabIndex++
			},
			toPre() {
				this.tabIndex--
				this.getTeacherInfo()
				if(this.tabIndex==7){
					this.timeListNew()
				}
			},
			delItem(index) {
				this.aotuForm.show_store_data.splice(index, 1)
			},
			setDate() {
				this.selectRangeItem()
			},
			monthList() {
				let timeRanges = [],
					arr = []
				this.weekCountList.forEach((item, index) => {
					if (this.selectWeek == item.week) {
						timeRanges = item.timeRanges
					}
				})

				timeRanges.forEach(range => {
					var startTime = moment(range.start, 'HH:mm'); // 将开始时间解析为 moment 对象
					var endTime = moment(range.end, 'HH:mm'); // 将结束时间解析为 moment 对象

					// 循环计算时间节点
					while (startTime < endTime) {
						let str = startTime.format('HH:mm')
						// console.log(startTime.format('HH:mm')); // 输出当前时间节点
						let endStr = endTime.format('HH:mm')

						// 计算时差
						let startDate = new Date('2000-01-01T' + str + ':00');
						let endDate = new Date('2000-01-01T' + endStr + ':00');
						let timeDiff = endDate - startDate;
						let minutesDiff = Math.floor(timeDiff / 60000);
						if (minutesDiff >= this.aotuForm.private_scheduling_duration) {
							arr.push(str)
						}
						if (this.aotuForm.private_scheduling_interval != '' && this.aotuForm
							.private_scheduling_interval != 0) {
							startTime = startTime.add(this.aotuForm.private_scheduling_interval, 'minutes');

						} else if (this.aotuForm.private_scheduling_duration != '' && this.aotuForm
							.private_scheduling_duration != 0) {
							startTime = startTime.add(this.aotuForm.private_scheduling_duration, 'minutes');
						}

					}
					// 排序时间数组
					arr.sort((a, b) => {
						const [aHours, aMinutes] = a.split(':').map(Number);
						const [bHours, bMinutes] = b.split(':').map(Number);
						return aHours === bHours ? aMinutes - bMinutes : aHours - bHours;
					});
				});
				this.showTimeList = arr
				console.log("this.showTimeList",this.aotuForm);
			},
			// 每次选完时间段后处理数据格式
			selectRangeItem() {
				if (this.aotuForm.private_scheduling_duration == '') {
					// this.$message.error("请输入时间间隔");
					return
				}
				let arr = [],
					list = []
				this.weekCountList = []
				this.aotuForm.show_store_data.forEach((item, index) => {
					item.start_s = item.rengeTime[0]
					item.end_s = item.rengeTime[1]
					item.day_index.forEach(it => {
						arr.push({
							week: it,
							timeRanges: [{
								start: item.rengeTime[0],
								end: item.rengeTime[1]
							}],
							range: {
								start: item.rengeTime[0],
								end: item.rengeTime[1]
							}
						})
					})
				})
				arr.forEach((item, index) => {
					if (!list.includes(item.week)) {
						list.push(item.week)
						this.weekCountList.push(item)
					} else {
						this.weekCountList.forEach((it, ind) => {
							if (item.week == it.week) {
								it.timeRanges.push(item.range)
							}
						})
					}

				})
				this.monthList()
			},
			// 添加时间段
			addList() {
				if (this.aotuForm.show_store_data[this.aotuForm.show_store_data.length - 1].day_index == '' || this
					.aotuForm
					.show_store_data[this.aotuForm.show_store_data.length - 1].rengeTime == '') {
					this.$message.error("请选择预约时间");
					return
				}
				this.aotuForm.show_store_data.push({
					rengeTime: [],
					start_s: '',
					end_s: '',
					day_index: [1, 2, 3, 4, 5, 6, 7]
				})
			},
			divideIntoHandleCancel() {
				this.divideIntoVisible = false
			},
			
		}
	}
</script>

<style scoped>
	::v-deep.ant-radio-group-solid .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
		background: #3e9699;
		border-color: #3e9699;
	}
	::v-deep .ant-checkbox-checked .ant-checkbox-inner{
		background-color: #52C4C9;
		border-color: #52C4C9;
	}
	::v-deep.form-check-input:checked{
		background-color: #52C4C9;
		border-color: #52C4C9;
	}
	::v-deep.mainIndex-class-select .ant-select-selection{
		border-radius: 0.375rem !important;
		border: 1px solid #dee2e6;
	}
	::v-deep.mainIndex-class-select .anticon{
		color: #000 !important;
	}
	.becomeTeacher-wid {
		width: 630px;
	}

	.becomeTeacher-wid-25 {
		width: 25%;
	}

	.becomeTeacher-hei {
		height: 70px;
	}

	.as-reservation-time {
		background-color: rgb(242, 242, 242);
		padding: 12px;
	}

	.as-reservation-time-item-del {
		position: absolute;
		top: 7px;
		right: 8px;
		cursor: pointer;
	}

	.as-reservation-time-item {
		position: relative;
		background-color: #ffffff;
		border-radius: 4px;
		padding: 8px;
	}

	.as-show-list-item {
		border: 1px solid #ebedf5;
		width: 54px;
		text-align: center;
		margin-bottom: 6px;
		margin-right: 6px;
		padding: 6px 0;
		border-radius: 4px;
		background-color: #fff;
	}

	@media (max-width:575.98px) {
		.becomeTeacher-wid {
			width: 100%;
		}
	}

	.video-item {
		margin-right: 20px;
	}
	.ql-editor img {
	  max-width: 100%;
	  height: auto;
	  display: block;
	  margin: 10px 0;
	}
</style>